const EXCERPT_AREA_SELECTOR = ".rc-excerpt-area";
// The word's own text renders last inside the span: `word-decorations` content (IDI's rc-e-i token link) precedes it.
const wordTextNode = (word) => {
    const texts = Array.from(word.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE && node.data.trim().length > 0);
    return texts[texts.length - 1] ?? null;
};
const inOrder = (from, to) => from.compareDocumentPosition(to) & Node.DOCUMENT_POSITION_PRECEDING ? [to, from] : [from, to];
// Both edges land on a word's own text node, so sub_idx stays 0 and start_idx names that word's token exactly.
export const buildWordRange = (from, to) => {
    const [first, last] = inOrder(from, to);
    const startText = wordTextNode(first);
    const endText = wordTextNode(last);
    if (!startText || !endText)
        return null;
    const range = first.ownerDocument.createRange();
    range.setStart(startText, 0);
    range.setEnd(endText, endText.data.length);
    return range;
};
// A selection spanning two focus areas is rejected by the engine, so both words must share one.
export const sharedExcerptArea = (from, to) => {
    const area = from.closest(EXCERPT_AREA_SELECTOR);
    return area && area === to.closest(EXCERPT_AREA_SELECTOR) ? area : null;
};
export const selectWordRange = (from, to) => {
    if (!sharedExcerptArea(from, to))
        return false;
    const range = buildWordRange(from, to);
    const selection = from.ownerDocument.defaultView?.getSelection();
    if (!range || !selection)
        return false;
    selection.removeAllRanges();
    selection.addRange(range);
    return true;
};
